import React from 'react'
import GradientText from './Animations/GradientText'
import BlurText from './Animations/BlurText'
import ShinyText from './Animations/ShinyText'
import SplitText from './Animations/SplitText'

export default function Roadmap() {
    return (
        <div className='md:mt-[8vw] mt-[15vw] relative' id='Roadmap'>
            <div className='md:w-[70%] w-[90%] mx-auto lg:pl-20 flex flex-col items-center justify-center'>
                <div className='bg-black md:px-5 py-1 rounded-3xl w-fit md:mb-5 mb-2'>
                    <GradientText
                        colors={["#40ffaa", "#BEFFCD", "#7358F9",]}
                        animationSpeed={3}
                        showBorder={false}
                        className="font-semibold md:text-lg text-sm "
                    >
                        STEPS WE FOLLOW
                    </GradientText>
                </div>
                <BlurText
                    text="Our Roadmap"
                    delay={300}
                    animateBy="words"
                    direction="top"
                    className="md:text-5xl text-3xl font-medium !text-center md:mb-5 mb-2"
                />
                <ShinyText text="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. "
                    disabled={false} speed={3} className='md:text-2xl text-[10px] text-wrap font-normal text-center' />
            </div>
            <div className='relative'>
                <img src="/images/roadmap-bg-layar.png" alt="" className='blink_animation' />
                <div className='grid md:grid-cols-3 grid-cols-1 gap-5 lg:w-[80%] w-[90%] mx-auto -mt-[50vw]'>
                    <div className='md:mt-[10vw] mt-[10vw]'>
                        <SplitText
                            text="Foundation phase"
                            className="text-2xl font-medium "
                            delay={150}
                            animationFrom={{ opacity: 0, transform: 'translate3d(0,50px,0)' }}
                            animationTo={{ opacity: 1, transform: 'translate3d(0,0,0)' }}
                            easing="easeOutCubic"
                            threshold={0.2}
                            rootMargin="-50px"
                        />
                        <ul className='pl-5 list-disc mt-5 text-gray-500'>
                            <li>Website v1.0</li>
                            <li>Dextools Update</li>
                            <li>Dexsc Update</li>
                            <li>CG & CMC Submission</li>
                            <li>Twitter Blue</li>
                            <li>1000+ Holders</li>
                            <li>Basic Exposure </li>
                        </ul>
                    </div>
                    <div>
                        <SplitText
                            text="Adoption phase"
                            className="text-2xl font-medium "
                            delay={150}
                            animationFrom={{ opacity: 0, transform: 'translate3d(0,50px,0)' }}
                            animationTo={{ opacity: 1, transform: 'translate3d(0,0,0)' }}
                            easing="easeOutCubic"
                            threshold={0.2}
                            rootMargin="-50px"
                        />
                        <ul className='pl-5 list-disc mt-5 text-gray-500'>
                            <li>DORA Functionality Demos </li>
                            <li>GRIFFAIN Working Guide</li>
                            <li>DORA Working Guide</li>
                            <li>Griffain as Top Holder</li>
                            <li>10,000+ Holders</li>
                            <li>Extensive exposure </li>
                        </ul>
                    </div>
                    <div className='md:mt-[10vw] mt-[10vw] md:pl-[7vw]'>
                        <SplitText
                            text="Maturity phase"
                            className="text-2xl font-medium "
                            delay={150}
                            animationFrom={{ opacity: 0, transform: 'translate3d(0,50px,0)' }}
                            animationTo={{ opacity: 1, transform: 'translate3d(0,0,0)' }}
                            easing="easeOutCubic"
                            threshold={0.2}
                            rootMargin="-50px"
                        />
                        <ul className='pl-5 list-disc mt-5 text-gray-500'>
                            <li>Cross Agents Support</li>
                            <li>DORA’ trade as an Investment</li>
                            <li>$AD Buybacks + Burns</li>
                            <li>Griffain Access (By Invites) to core community members</li>
                            <li>CEXs listings</li>
                            <li>50,000+ Holders</li>
                        </ul>
                    </div>
                </div>
                <img src="/images/roadmap.png" alt="" className='md:block hidden w-[60%] mx-auto -mt-[8vw]' />
                <img src="/images/glop-2.png" alt="" className='rotate_animation md:absolute static md:w-[40vw] w-full md:scale-100 scale-125 mx-auto md:mt-0 -mt-10 bottom-[8vw] left-[30vw]' />
            </div>

        </div>
    )
}
